const App = () => {
	return (
		<div className='App'>
			<h1>Welcome to React</h1>
		</div>
	);
};

export default App;
